"use client";

import { trackEvent } from "./track-event";

interface ContactTrackingProps {
	category: "call" | "whatsapp" | "mail" | "escalation" | "general";
	additionalOptions?: Record<string, unknown>;
}

/**
 * Track contact events with different categories
 * Based on events from i/webapp/pages/contact.js
 */
export function trackContact({ category, additionalOptions = {} }: ContactTrackingProps) {
	trackEvent({
		google: {
			event: "contact",
			options: {
				event_category: category,
				...additionalOptions,
			},
		},
		matomo: {
			event: `click on ${category}`,
			options: {
				category: "contact",
			},
		},
	});
}

/**
 * Track contact via phone call
 * Based on i/webapp/pages/contact.js line 39
 */
export function trackContactCall() {
	trackContact({ category: "call" });
}

/**
 * Track contact via WhatsApp
 * Based on i/webapp/pages/contact.js line 53
 */
export function trackContactWhatsApp() {
	trackContact({ category: "whatsapp" });
}

/**
 * Track contact via email
 * Based on i/webapp/pages/contact.js line 83
 */
export function trackContactMail() {
	trackContact({ category: "mail" });
}

/**
 * Track escalation contact
 * Based on i/webapp/pages/contact.js line 99
 */
export function trackContactEscalation() {
	trackContact({ category: "escalation" });
}

/**
 * Track general contact action
 */
export function trackContactGeneral(additionalOptions?: Record<string, unknown>) {
	trackContact({ category: "general", additionalOptions });
}
